import { useUserStore } from "./store/UserStore";

export function getAssistWidgetIdentity() {
    try {
        let details = useUserStore.getState()?.userDetails;
        if (!details || details.id === null || details.id === undefined || String(details.id).trim() === "") {
            const raw = localStorage.getItem("userDetails");
            if (raw) {
                const parsed = JSON.parse(raw);
                details = parsed?.state?.userDetails || parsed?.userDetails || parsed;
            }
        }

        const rawId = details?.id;
        if (rawId === null || rawId === undefined || String(rawId).trim() === "") {
            return undefined;
        }

        return {
            externalId: String(rawId).trim(),
            firstName: details?.firstName?.trim() || undefined,
            middleName: details?.middleName?.trim() || undefined,
            lastName: details?.lastName?.trim() || undefined,
            email: details?.email?.trim() || undefined,
            phone: details?.phone?.trim() || undefined,
        };
    } catch (error) {
        console.warn("Failed to resolve Assist identity:", error);
        return undefined;
    }
}

export function initCmrWidget() {
    if (!window.CMRWidget) {
        console.error("CMRWidget failed to load");
        return;
    }

    const identity = getAssistWidgetIdentity();

    window.CMRWidget.init({
        source: process.env.REACT_APP_CMR_WIDGET_SOURCE,
        identity,
        organizationId: process.env.REACT_APP_CMR_WIDGET_ORG_ID,
        apiKey: process.env.REACT_APP_CMR_WIDGET_API_KEY,
        apiBaseUrl: process.env.REACT_APP_CMR_WIDGET_API_BASE_URL,
        socketUrl: process.env.REACT_APP_CMR_WIDGET_SOCKET_URL,
        position: process.env.REACT_APP_CMR_WIDGET_POSITION || "bottom-right",
        theme: process.env.REACT_APP_CMR_WIDGET_THEME || "light",
        primaryColor: process.env.REACT_APP_CMR_WIDGET_PRIMARY_COLOR || "#14508c",
    });
}
